import usePageData from './usePageData'
import { Brand, BrandNames } from '../types/brand'
import useSiteData, { SiteProp } from './useSiteData'

export function useBrand(): Partial<Brand & SiteProp> {
  const { brand } = usePageData()
  const site = useSiteData()

  if (!brand) {
    return {}
  }

  brand.flagshipProduct = site.default_resume_product

  if (brand.name.toLowerCase() === BrandNames.topCvUk) {
    brand.name = site.display_name
  }

  const isTopResume = brand.name.toLowerCase() === BrandNames.topResume
  const isTopCV = brand.name.toLowerCase() === BrandNames.topCv
  const isTopCVuk = brand.name.toLowerCase() === BrandNames.topCvUk
  const isZipJob = brand.name.toLowerCase() === BrandNames.zipJob
  const isTopCvFr = brand.name.toLowerCase() === BrandNames.TopCvFr
  const isTopCvDe = brand.name.toLowerCase() === BrandNames.TopCvDe

  return {
    ...brand,
    ...site,
    isTopResume,
    isTopCV,
    isTopCVuk,
    isZipJob,
    isTopCvFr,
    isTopCvDe,
  }
}

export default useBrand
